import { queryOptions } from "@tanstack/react-query";
import { listParameters } from "./api";
import { type TParamContext } from './ParamContext';

type ListParametersSelectFn = (listParametersData: Record<string, string | string[]>) => TParamContext;
//If no staleTime is provided query defaults to Infinity
export const listParametersQueryOpts = (serviceName: string, paramNames: string[], select?: ListParametersSelectFn, staleTime?: number) => queryOptions({
  queryKey: ['listParameters', serviceName, ...paramNames],
  queryFn: async () => {
    const data = await listParameters({ paramService: serviceName, paramNames: paramNames });
    return data;
  },
  select: select,
  enabled: false,
  staleTime: staleTime ?? Infinity
});

